import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PModalConfirmComponent } from '@components/modals/p-modal-confirm/p-modal-confirm.component';

@Component({
	selector: 'app-modal-not-auth',
	standalone: true,
	imports: [CommonModule, PModalConfirmComponent],
	templateUrl: './modal-not-auth.component.html',
	styleUrls: ['./modal-not-auth.component.css']
})
export class ModalNotAuthComponent {
	constructor() {}
}
